import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FeatureContainer = styled.div({
	display: 'grid',
	alignItems: 'end',
	gridTemplateColumns: '4fr 1fr',
	gridTemplateRows: 'repeat(2, auto)',
	gridTemplateAreas: `
        "feature-text feature-text"
        "toggle-text toggle"
    `,
	maxWidth: '1000px',
	paddingTop: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FeatureTextContainer = styled.div({
	gridArea: 'feature-text',
	paddingBottom: token('space.200', '16px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FeatureSubtitle = styled.div({
	paddingTop: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FeatureToggleText = styled.div<{ isDisabled?: boolean }>(
	{
		gridArea: 'toggle-text',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	(props) => (props.isDisabled ? `opacity: ${token('opacity.disabled', '0.5')}` : ''),
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FeatureToggle = styled.div({
	justifySelf: 'end',
	alignSelf: 'center',
	gridArea: 'toggle',
	disabled: 'true',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SectionWrapper = styled.div({
	padding: `${token('space.200', '16px')} 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HorizontalSeperator = styled.div({
	height: '1px',
	margin: `${token('space.500', '40px')} 0`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.border', colors.N40),
});
